import React from "react";
import Slider from "react-slick";

import brandLogo1 from "../../../assets/img/partner1.jpg";
import brandLogo2 from "../../../assets/img/partner2.jpg";
import brandLogo3 from "../../../assets/img/partner3.jpg";
import brandLogo4 from "../../../assets/img/partner4.jpg";
import brandLogo5 from "../../../assets/img/partner5.jpg";
import brandLogo6 from "../../../assets/img/brand/6.png";
import brandLogo7 from "../../../assets/img/partner7.png";
import brandLogo8 from "../../../assets/img/partner8.webp";

const BrandThree = (props) => {
  const { brandBg, brandClass } = props;

  const brandBgStyle = {
    backgroundImage: `url(${brandBg ? brandBg : ""})`,
  };

  const brandBgDefaultStyle = {
    backgroundColor: "transparent",
  };

  const sliderSettings = {
    dots: false,
    centerMode: false,
    infinite: true,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div
      className={brandClass ? brandClass : "rs-partner style2 pt-120 md-pt-80"}
      style={brandBg ? brandBgStyle : brandBgDefaultStyle}
    >
      <div className="container">
        <Slider {...sliderSettings}>
          <div className="partner-item">
            <div className="logo-img">
              <a href="#">
                <img src={brandLogo1} alt="" />
              </a>
            </div>
          </div>
          <div className="partner-item">
            <div className="logo-img">
              <a href="#">
                <img src={brandLogo2} alt="" />
              </a>
            </div>
          </div>

          <div className="partner-item">
            <div className="logo-img">
              <a href="#">
                <img src={brandLogo7} alt="" />
              </a>
            </div>
          </div>
          <div className="partner-item">
            <div className="logo-img">
              <a href="#">
                <img src={brandLogo8} alt="" />
              </a>
            </div>
          </div>
          <div className="partner-item">
            <div className="logo-img">
              <a href="#">
                <img src={brandLogo3} alt="" />
              </a>
            </div>
          </div>
          <div className="partner-item">
            <div className="logo-img">
              <a href="#">
                <img src={brandLogo4} alt="" />
              </a>
            </div>
          </div>
          <div className="partner-item">
            <div className="logo-img">
              <a href="#">
                <img src={brandLogo5} alt="" />
              </a>
            </div>
          </div>
          <div className="partner-item">
            <div className="logo-img">
              <a href="#">
                <img src={brandLogo6} alt="" />
              </a>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default BrandThree;
